/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_ZoneInputs */

const en_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Safe Zone`)
};

const es_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona segura`)
};

const fr_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zone de sécurité`)
};

const de_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sicherer Bereich`)
};

const ja_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`セーフゾーン`)
};

const zh_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`安全区域`)
};

const ar_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنطقة الآمنة`)
};

const id_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona Aman`)
};

const it_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area sicura`)
};

const ru_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безопасная зона`)
};

const pt_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zona segura`)
};

const ko_safe_zone = /** @type {(inputs: Safe_ZoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`안전 영역`)
};

/**
* | output |
* | --- |
* | "Safe Zone" |
*
* @param {Safe_ZoneInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const safe_zone = /** @type {((inputs?: Safe_ZoneInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_ZoneInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_safe_zone(inputs)
	if (locale === "es") return es_safe_zone(inputs)
	if (locale === "fr") return fr_safe_zone(inputs)
	if (locale === "de") return de_safe_zone(inputs)
	if (locale === "ja") return ja_safe_zone(inputs)
	if (locale === "zh") return zh_safe_zone(inputs)
	if (locale === "ar") return ar_safe_zone(inputs)
	if (locale === "id") return id_safe_zone(inputs)
	if (locale === "it") return it_safe_zone(inputs)
	if (locale === "ru") return ru_safe_zone(inputs)
	if (locale === "pt") return pt_safe_zone(inputs)
	return ko_safe_zone(inputs)
});